import { SAFETY } from './data';
const PROTOCOLS = [
  'OSHA-30 certification required for all foremen, OSHA-10 for all crew · 100% compliance',
  'Daily 7am stand-down · attendance logged on Procore · two-week look-ahead reviewed',
  'Job-Hazard Analysis (JHA) for every new task · signed by foreman + crew',
  'PPE provided · hard-hat, safety-glass, hi-vis, steel-toe, gloves, hearing where required',
  'Weekly tool-box talk · 12 minutes · attendance & topic logged',
  'Drug-and-alcohol policy · pre-employment, post-incident, random panel quarterly',
  'Subcontractor pre-qualification · 92-point dossier · insurance verified at gate',
  'Near-miss reporting · 24-hour rule · 188 reported in 2025, 0 became incidents',
];
export default function Safety() {
  return (
    <div className="bg-[#D9D4CC] text-[#1F2126] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1F2126]"><p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#FF7A1A] bg-[#1F2126] inline-block px-2 py-0.5 mb-3">— 02 / Safety binder · 24 mo. injury-free</p><h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The safety binder.</h1></section>
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-12">
        <div className="grid md:grid-cols-4 gap-3 mb-10">
          {SAFETY.map(s => (
            <div key={s.kpi} className="bg-[#1F2126] text-[#D9D4CC] p-5"><p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FF7A1A]">{s.kpi}</p><p className="font-serif text-4xl mt-1">{s.v}</p><p className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#D9D4CC]/55 mt-1">{s.n}</p></div>
          ))}
        </div>
        <div className="border-2 border-[#1F2126] bg-[#FAFAF6]">
          <div className="bg-[#1F2126] text-[#FF7A1A] px-6 py-3 font-mono text-[10px] tracking-[0.32em] uppercase">— Eight protocols on every Ironworks job —</div>
          <ul className="divide-y-2 divide-[#1F2126]/15">
            {PROTOCOLS.map((p, i) => (
              <li key={i} className="grid grid-cols-[60px_1fr] gap-4 px-6 py-4 items-baseline"><span className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FF7A1A]">[{String(i + 1).padStart(2, '0')}]</span><span className="font-sans text-base text-[#1F2126]/85" dangerouslySetInnerHTML={{ __html: p }} /></li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
